<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.editEmployeeHeader | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="eeForm" (ngSubmit)="save()">
    <!-- Basic -->
    <div class="section-header-container">
      <h2 class="overline grey1 semibold section-title">{{ data.sysText.basicInfo }}</h2>
      <mat-divider class="section-header-underline"></mat-divider>
    </div>
    <div [ngClass]="(isMobile$ | async) ? 'main-container' : 'main-container flex'">
      <div [ngClass]="(isMobile$ | async) ? 'column-container' : 'column-container width-46'">
        <app-input-field
          [label]="data.sysText.caseEmployeeInfo_firstName"
          [control]="eeForm.controls.firstName"
          [group]="eeForm"
          [hideIconSpace]="true"
          [autocomplete]="'given-name'"
        ></app-input-field>
        <div class="last-suffix-container">
          <app-input-field
            class="last-name"
            [label]="data.sysText.caseEmployeeInfo_lastName"
            [control]="eeForm.controls.lastName"
            [group]="eeForm"
            [hideIconSpace]="true"
            [autocomplete]="'family-name'"
          ></app-input-field>
          <app-input-field
            class="suffix"
            [label]="data.sysText.caseEmployeeInfo_suffix"
            [control]="eeForm.controls.suffix"
            [group]="eeForm"
            [hideIconSpace]="true"
            [autocomplete]="'honorific-suffix'"
          ></app-input-field>
        </div>
      </div>
      <div [ngClass]="(isMobile$ | async) ? 'column-container' : 'column-container width-46'">
        <app-input-field
          [label]="data.sysText.caseEmployeeInfo_middleName"
          [control]="eeForm.controls.middleName"
          [group]="eeForm"
          [hideIconSpace]="true"
          [autocomplete]="'additional-name'"
        ></app-input-field>
        <app-input-field
          [label]="data.sysText.prefferedFirstName"
          [control]="eeForm.controls.preferredFirstName"
          [group]="eeForm"
          [hideIconSpace]="true"
          [autocomplete]="'nickname'"
        ></app-input-field>
      </div>
    </div>

    <!-- Contact Info -->
    <div class="section-header-container">
      <h2 class="overline grey1 semibold section-title">{{ data.sysText.contactInfo }}</h2>
      <mat-divider class="section-header-underline"></mat-divider>
    </div>
    <div class="column-container">
      <app-email-field-group
        [group]="eeForm"
        [workEmailControl]="eeForm.controls.workEmail"
        [isWorkEmailPreferredControl]="eeForm.controls.workEmailChecked"
        [personalEmailControl]="eeForm.controls.personalEmail"
        [isPersonalEmailPreferredControl]="eeForm.controls.personalEmailChecked"
        [autocomplete]="'email'">
      </app-email-field-group>
    </div>
    <div [ngClass]="(isMobile$ | async) ? 'main-container' : 'main-container flex'">
      <div [ngClass]="(isMobile$ | async) ? 'column-container' : 'column-container width-46'">
        <app-input-field
          [group]="eeForm"
          [control]="eeForm.controls.workPhone"
          [icon]="'phone'"
          [label]="data.sysText.workPhone"
          [inputType]="'string'"
          [autocomplete]="'work tel'"
        ></app-input-field>
      </div>
      <div [ngClass]="(isMobile$ | async) ? 'column-container' : 'column-container width-46'">
        <app-input-field
          [group]="eeForm"
          [control]="eeForm.controls.personalPhone"
          [label]="data.sysText.personalPhone"
          [autocomplete]="'home tel'"
        ></app-input-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!isSubmitting && this.eeForm.errors?.msError) {
    <mat-error class="mse-form-error caption">
      {{ this.eeForm.errors?.msError }}
    </mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>